export default __webpack_public_path__ + "static/media/PMK.79864677.png";